import SEO from "@/components/site/SEO";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Intro from "@/components/site/Intro";
import Traditions from "@/components/site/Traditions";
import Gallery from "@/components/site/Gallery";
import Events from "@/components/site/Events";
import SisterBrand from "@/components/site/SisterBrand";
import QuoteForm from "@/components/site/QuoteForm";
import About from "@/components/site/About";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen">
      <SEO />
      <Nav />
      <main>
        <Hero />
        <Intro />
        <Traditions />
        <Gallery />
        <Events />
        <SisterBrand />
        <QuoteForm />
        <About />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
